import { render } from "./CheckableTag.vue?vue&type=template&id=2e093e0e"
import script from "./CheckableTag.vue?vue&type=script&lang=js"
export * from "./CheckableTag.vue?vue&type=script&lang=js"
script.render = render

export default script